

app.controller('RegisterCtrl',
    ['$scope', '$rootScope', '$http', '$window', '$q', '$translate', '$filter','$routeParams',
    function ($scope, $rootScope, $http, $window, $q, $translate, $filter, $routeParams) {
        $scope.user = {
            Email: '',
            Password: '',
            Handphone: '',
            QuestionRDN: '',
            FirstName: '',
            BankNumber: '',
            BankOwner: '',
            Sales: '',
            BrokerCode: '',
            BankAccountName1: '',
            Mitra: '',
            ReferalNumber: '',
            challenge: ''
        };


        $scope.user.PhoneCode = '+62';
        $scope.ConfirmPassword = '';
        $scope.disclaimerRek = false;
        $scope.disableQuestionRDN = false;
        $scope.disableBank = false;
        $scope.disableReferalNumber = false;
        $scope.user.QuestionRDN = '';
        $scope.SalesSelected = '';
        $scope.ListSales = [];
        $scope.ReferralSelected = '';
        $scope.ListReferral = [];
        $scope.ListBank = [];
        $scope.tmpBankSelected = '';
        $scope.bankpribadi = '';

        $scope.page = 'step1';

        $scope.showPassword = false;
        $scope.inputType = 'password';
        $scope.pattern = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*+`~'?=|[\\[\\]()<>/_-]).{10,}$";
        $scope.toggleShowPassword = function () {
            $scope.showPassword = !$scope.showPassword;
            if ($scope.inputType == 'password')
                $scope.inputType = 'text';
            else
                $scope.inputType = 'password';
        }

        $scope.showPasswordConfirmation = false;
        $scope.inputTypeConfirmation = 'password';
        $scope.toggleShowPasswordConfirmation = function () {
            $scope.showPasswordConfirmation = !$scope.showPasswordConfirmation;
            if ($scope.inputTypeConfirmation == 'password')
                $scope.inputTypeConfirmation = 'text';
            else
                $scope.inputTypeConfirmation = 'password';
        }

        $scope.checkPassword = function () {
            if ($scope.ConfirmPassword != $scope.user.Password) {
                $scope.formRegister.txtConfirmPassword.$invalid = true;
                $scope.infolengthpass = false;
            }
        };

        $scope.selectSales = function (item, model, label, event) {
            if (item.SalesPersonNID) {
                $scope.user.Sales = item.SalesPersonNID;
                $scope.SalesSelected = item;

            }

        };


        $scope.selectReferral= function (item, model, label, event) {
            if (item.ReferralNID) {
                $scope.user.ReferalNumber = item.ReferralNID;
                $scope.ReferralSelected = item;

            }

        };

        if ($routeParams.id) {

            $scope.sales = $routeParams.id;
            console.log('coba', $scope.sales);
            $http({
                method: 'GET',
                url: '/service/client.svc/GetAliasSales?alias=' + $scope.sales,
                cache: true,
            }).then(function (data) {
                $scope.user.Sales = data.data.d.SalesPersonNID;
                console.log('SalesPersonNID', $scope.sales);
                $scope.SalesSelected = data.data.d
                if ($scope.user.Sales == 3255) {
                    $scope.user.BankAccountName1 = 'PT. BANK AMAR INDONESIA Tbk';
                    $scope.user.ReferalNumber = 'RM111206';
                    $scope.user.QuestionRDN = 'PERMATA';
                    $scope.user.ClientNCategory = 1;
                    $scope.disableQuestionRDN = true;
                    $scope.disableBank = true;
                    $scope.disableReferalNumber = true;
                }
                if ($scope.user.Sales == 3155) {
                    $scope.user.ReferalNumber = 'SHAHRIN';
                    $scope.disableReferalNumber = true;
                }
                console.log($scope.SalesSelected);
                $scope.disablesales = true;
            }, function (error) { });
        }


        $scope.trim = function () {
            $scope.user.Email = $scope.user.Email ? $scope.user.Email.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.Email;
            $scope.user.Password = $scope.user.Password ? $scope.user.Password.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.Password;
            $scope.user.Handphone = $scope.user.Handphone ? $scope.user.Handphone.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.Handphone;
            $scope.user.FirstName = $scope.user.FirstName ? $scope.user.FirstName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.FirstName;
            $scope.user.BankNumber = $scope.user.BankNumber ? $scope.user.BankNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.BankNumber;
            $scope.user.BankOwner = $scope.user.BankOwner ? $scope.user.BankOwner.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.BankOwner;
            $scope.user.BankAccountName1 = $scope.user.BankAccountName1 ? $scope.user.BankAccountName1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, '') : $scope.user.BankAccountName1;
        }

        $scope.ngModelOptionsSelected = function (value) {
            if (arguments.length) {
                _selected = value;
            } else {
                return _selected;
            }
        };

        $scope.modelOptions = {
            debounce: {
                default: 100,
                blur: 100
            },
            getterSetter: true
        };


        $scope.selectBank = function (item, model, label, event) {
            // console.log('item',item);
            // console.log('model',model);
            // console.log('label',label);
            // console.log('event',event);
            if (item.BankID) {
                $scope.user.BankAccountName1 = item.BankName;
                //$scope.tmpBankSelected = item;

            }
        };

        $scope.changeBankRDN = function () {
            // $scope.tmpBankSelected = '';
            // $scope.user.BankAccountName1 = '';
            if ($scope.user.QuestionRDN == 'BCA') {
                //let tmpBank = $filter('filter')($scope.ListBank, { BankID: 'BBCA' }, true)[0];
                //console.log('xxxx');
                ////$scope.selectBank(tmpBank,'BBCA - PT. BANK CENTRAL ASIA, Tbk.','BBCA - PT. BANK CENTRAL ASIA, Tbk.','')
                $scope.user.BankAccountName1 = 'PT. BANK CENTRAL ASIA, Tbk.'

                //$scope.ngModelOptionsSelected = 'PT. BANK CENTRAL ASIA, Tbk.';
                //$scope.$apply();
            }
            else {

            }
        }




        $scope.checkBankNumber = function () {
            if ($scope.user.BankNumber) {
                //$http({
                //    method: 'GET',
                //    url: 'service/client.svc/checkBankNumber?BK=' + $scope.user.BankNumber,
                //    cache: false
                //}).then(function (data) {
                //    if (data.data.d != null) {
                //        var obj = data.data.d;
                //        if (obj.key && obj.key == 1) {
                //            $scope.user.BankNumber = '';
                //            swal('Gagal', obj.value, "error");
                //        }
                //    }
                //}, function (error) { });
            }
        }



        var allPromise = $q.all([
            $http({
                method: 'GET',
                url: 'service/client.svc/GetPED',
            }).then(function (data) {

                if (data.data.d != null) {
                    $scope.broker = data.data.d;
                    $scope.user.BrokerCode = $scope.broker.BROKERCode;
                }
            }, function (error) { }),

             $http({
                 method: 'GET',
                 url: 'service/client.svc/GetCIFSales',
                 cache: false,
             }).then(function (data) {
                 $scope.ListSales = data.data.d;
             }, function (error) { }),

             $http({
                 method: 'GET',
                 url: 'service/client.svc/GetCIFReferral',
                 cache: false,
             }).then(function (data) {
                 $scope.ListReferral = data.data.d;
             }, function (error) { }),

             $http({
                 method: 'GET',
                 url: 'service/client.svc/GetCIFBank',
                 cache: true,
             }).then(function (data) {
                 $scope.ListBank = data.data.d;
             }, function (error) { }),
        ]);




        $scope.prepareData = function () {

            if ($scope.user.Sales == "")
                $scope.user.Sales = 1;

            $scope.user.BankOwner = $scope.user.FirstName;

            if (!$scope.user.BankAccountName1) {
                alert("Mohon ulangi pilihan bank pribadi");
                return false;
            }

            var challenge = grecaptcha.getResponse();
            if (!challenge) {
                alert("Mohon ulangi centang captcha");
                return false;
            } else {
                $scope.user.challenge = challenge;
            }

            console.log($scope.user);

            //console.log("RDN Non BCA ", $scope.user.BankOwner);


        }

        $scope.submit = function () {
            $scope.trim();
            $scope.prepareData();

            if (!$scope.user.BankAccountName1) {
                alert("Mohon ulangi pilihan bank pribadi");
                return false;
            }

            var challenge = grecaptcha.getResponse();
            if (!challenge) {
                alert("Mohon ulangi centang captcha");
                return false;
            }

            var urlsvc = 'service/client.svc/RegistrasiUser'; // 1
            var preconfirmtranslate = "submitregistrationconf"; // 2
            var postData = { User: $scope.user } // 3
            var method = "POST" // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                if (issuccess) // 6
                    $window.location.href = "#/login";

            });
        }


        allPromise.then(function () {

        });


    }]);



















app.controller('ActivationCtrl',
    ['$scope', '$routeParams', '$rootScope', '$http', '$window', '$q', '$translate',
    function ($scope, $routeParams, $rootScope, $http, $window, $q, $translate) {
        $scope.user = {
            Email: '',
            OTP: '',
        };

        $scope.printXyz = function () {
            console.log($scope.user);
            console.log('CODE', $scope.user.code1);
            console.log('EMAIL', $scope.user.Email);
        }

        if ($routeParams.email) {
            $scope.user.generatedkey = $routeParams.generatedkey;
        }
        //else {
        //    $window.location.href = "#/register";
        //    $window.location.reload();
        //}

        $scope.page = 'activation';

        var allPromise = $q.all([

            $http({
                method: 'GET',
                url: 'service/client.svc/recheckActivationLink?key=' + window.location.href.substr(window.location.href.lastIndexOf('/') + 1),
            }).then(function (data) {
                $scope.result = data.data.d;
                $scope.Email = $scope.result.email;
                var SWALtranslate = $scope.SWALtranslate($scope.result.message);
                if ($scope.result.message == "LinkExpired") {

                    $rootScope.AlertShowFooter('warning', SWALtranslate.title, SWALtranslate.message,
                        `<small><a id="resendOTP" >` + SWALtranslate.footer + `</a></small>`, 0);

                    $("#resendOTP").on("click", function () {

                        var urlsvc = 'service/client.svc/resendOTP?emailto=' + $scope.Email; // 1
                        var preconfirmtranslate = "resendactivationlink"; // 2 
                        var postData = {}; // 3
                        var method = "GET"; // 4
                        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                            if (issuccess) // 6 
                                $window.location.href = "#/login";
                        });
                    });
                    return
                }
                else if ($scope.result.message == "LinkUsed") {
                    var SWALtranslate = $scope.SWALtranslate('LinkUsed');
                    Swal.fire(SWALtranslate.title, SWALtranslate.message, 'warning');

                    $window.location.href = "#/login";
                }
                else {

                    var SWALtranslate = $scope.SWALtranslate('activationsuccess');
                    Swal.fire(SWALtranslate.title, SWALtranslate.message, 'success');

                    $window.location.href = "#/login";

                }


            }, function (error) { }),

        ]);


        //$scope.submit = function () {
        //    $scope.user.OTP = $scope.user.code1 + $scope.user.code2 + $scope.user.code3 + $scope.user.code4;
        //    console.log('user', $scope.user);
        //    $translate('VALIDATE.confirmation').then(function (strText) {
        //        $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
        //        .then((result) => {
        //            if (result.value) {
        //                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
        //                $http({
        //                    method: 'POST',
        //                    url: 'service/client.svc/AktivasiUser',
        //                    data: {
        //                        User: $scope.user
        //                    }
        //                }).then(function (data) {

        //                    if (data.data.d.result) {
        //                        Swal.fire('Activation Success', data.data.d.message, 'success').then(function () {
        //                            $window.location.href = "#/login";
        //                            $window.location.reload();
        //                        });
        //                    }
        //                    else {
        //                        swal('Failed, Check OTP in Email', data.data.d.message, 'info');
        //                    }
        //                }, function (error) { });
        //            }
        //        });
        //    });
        //}


        allPromise.then(function () {

        });


        $scope.verif = function (index, event) {
            if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
                console.log('done1')
            else {
                if (index && ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
                    let focusCtrl = "#verif" + (index + 1);
                    angular.element(focusCtrl).focus();
                }
            }
        }

        $scope.processCb = function (event) {
            let data = event.originalEvent.clipboardData.getData('text/plain');
            if (data.length == 4) {
                $scope.code1 = data[0];
                $scope.code2 = data[1];
                $scope.code3 = data[2];
                $scope.code4 = data[3];
            }
        }

        $scope.verFocus = function (index) {
            if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
                console.log('done2')
            else {
                switch (index) {
                    case 1: $scope.code1 = ''; break;
                    case 2: $scope.code2 = ''; break;
                    case 3: $scope.code3 = ''; break;
                    case 4: $scope.code4 = ''; break;
                }
            }
        }
    }]);
